import React from 'react';
import { combineClassNames } from '../../../../app/functions';
import './index.scss';

const Tag = ({
    data,
    clickable = false,
    selectable = false,
    isSelected = false,
    onTagClick = () => {}
}) => {
    const handleClickEvent = () => onTagClick(data.id);

    return (
        <div
            className={combineClassNames(
                'shared-tag',
                clickable && 'shared-tag_clickable',
                selectable && isSelected && 'shared-tag_selected',
                selectable && !isSelected && 'shared-tag_unselected',
            )}
            onClick={handleClickEvent}
        >
            {data.title}
        </div>
    );
};

export default Tag;
